// extracted by mini-css-extract-plugin
export default {"image_section":"categorySelection_image_section__toJzd","main":"categorySelection_main__+bVZO"};